import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Autocomplete, CircularProgress, FormControl, InputLabel, MenuItem, Select, Snackbar, Stack, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { api } from '../../../../redux/api';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { getSelectedNodes } from '../../../RightContextMenu/ContextActions/CopyAndPaste';
import { useTranslation } from 'react-i18next';
import { treeActions } from '../../../../redux/slices/treeSlice';
import { isArray } from 'lodash';

export default function DatabaseFieldProperty({ handleChange }) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const parentScreen = useContext(ParentScreenCtx);
  const { account, user } = useSelector(state => state.queryParams);
  const connectedToDB = useSelector(state => state.treeData[parentScreen].rightTree.connectedToDB)
  const connectedDbTableList = useSelector(state => state.treeData[parentScreen].rightTree.connectedDbTableList)
  const [tableOptions, setTableOptions] = useState([]);
  const [table, setTable] = useState('');
  const [column, setColumn] = useState('');
  const [columnDropdown, setColumnDropdown] = useState();
  const [columnOptions, setColumnOptions] = useState([]);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const [showAlert, setShowAlert] = useState({ mssg: '', type: 'success', isOpen: false });
  const currentTab = rightTree.currentTab;
  const translatedData = rightTree.tree[currentTab].translatedData;
  const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
  const pdc = useSelector((state) => state.treeData[parentScreen].pdc);
  const tableLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.['TABLE_LOADING']?.isLoading || false);
  const columnLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.['COLUMN_LOADING']?.isLoading || false);
  const columnError = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.['COLUMN_LOADING']?.isError || false);
  const tableError = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.['TABLE_LOADING']?.isError || false);
  const connectedPDC = useSelector(state => state?.treeData?.[parentScreen]?.connectedPDC);
  const timerRef = useRef();


  const getColumnsData = (connection, schema, initialCall) => {
    const currTable = initialCall ? selectedNode.TABLE_NAME : table;
    const currColumn = initialCall ? selectedNode.COLUMN_NAME : column;
    if ( currTable && ![t('SELECT'), t('EMPTY_COMBO')].includes(currTable) && tableOptions?.filter(e => e === currTable)?.length && connectedPDC?.CONNECTION){
      if (timerRef.current) clearTimeout(timerRef.current);
      dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "COLUMN_LOADING", data: {isLoading: true, isError: false}}));
      dispatch(api.endpoints.get_database_column_info.initiate({
        account: account,
        user: user,
        table_name: currTable,
        pdc_name:connection,
        schema_name: schema,
        direction: parentScreen === "inbound" ? "IN" : "OUT",
      }, {forceRefetch : true})).then((res) => {
        if (res.data.current_state === 'SUCCESS' && isArray(res?.data?.data?.database_column_list)) {
          const dataArray = res?.data?.data?.database_column_list;
          const value = currColumn;
          setColumnOptions(
            [...(dataArray?.length ? [t('SELECT'), ...(!dataArray.includes(value) && value && ![t('SELECT'),t('EMPTY_COMBO')].includes(value) ? [value] : [])] 
              : [t('EMPTY_COMBO')]), ...dataArray?.map((e, i) => {
              return e;
            }) || []]
          );
        }
        else{
          const message = res?.data?.message;
          setShowAlert({ mssg: message, isOpen: true, type: 'warning' })
        }
      })
      // timerRef.current = setTimeout(() => {
      //   dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "COLUMN_LOADING", data: {isError: true}}));
      // }, 120000)
    } else {
      const value = currColumn ;
      const newData = [t('EMPTY_COMBO'), ...((value && ![t('SELECT'),t('EMPTY_COMBO')].includes(value)) ? [value] : [])];
      setColumnOptions(prev => newData)
    }
  }

  useEffect(() => {
    if (columnError && columnLoading) {
      setShowAlert({ mssg: t('BOX_MSG_GENERAL_ERROR'), isOpen: true, type: 'warning' });
      dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "COLUMN_LOADING", data: {isLoading: false, isError: false}}));
    }
    if (tableError && tableLoading) {
      setShowAlert({ mssg: t('BOX_MSG_GENERAL_ERROR'), isOpen: true, type: 'warning' });
      dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "TABLE_LOADING", data: {isLoading: false, isError: false}}));
    }
  },[columnError])


  const handleAlertClose = () => {
    setShowAlert({...showAlert, isOpen: false});
  }

  const tableAndColumnDropDownHandler = (info, setStates, initialCall) => {
    let parentKey = selectedNode?.key?.split('-');
    parentKey.splice(parentKey?.length - 1, 1);
    parentKey = parentKey.join('-');
    const parentNode = getSelectedNodes([parentKey], translatedData)?.[0];
    const connection = parentNode?.PREDEFINED ;
    const schema = parentNode?.SCHEMA ?  parentNode?.SCHEMA : parentNode?.PREDEFINED === connectedPDC?.CONNECTION ? connectedPDC?.SCHEMA : '';
    const dataArray = info?.type === "table" ? Object.keys(pdc?.[connection]?.[schema] || {}) : Object.keys(pdc?.[connection]?.[schema]?.[initialCall ? selectedNode?.TABLE_NAME : table] || {});
    const value = info?.type === "column" ? (initialCall ? selectedNode?.COLUMN_NAME  : column ): (initialCall ? selectedNode?.TABLE_NAME : table);
    if (info?.type === "column" && !dataArray.length) {
      getColumnsData(connection, schema, initialCall)
    }
    else if(connection && schema && (info?.type === "table" || (info?.type === "column" && initialCall ? selectedNode?.TABLE_NAME : table))) {
      const sorted = parentNode?.SORT_DB_COLUMNS || false;
      if (sorted) dataArray?.sort((a, b) => a.localeCompare(b));
      setStates( prev =>
        [...(dataArray?.length ? [t('SELECT'), ...(!dataArray.includes(value) && value ? [value] : [])] 
        : [t('EMPTY_COMBO'), ...(value && ![t('SELECT'),t('EMPTY_COMBO')].includes(value) ? [value] : [])]), ...dataArray?.map((e, i) => {
          return e
        }) || []]
        );
    }else {
      const newData = [t('EMPTY_COMBO'), ...((value && ![t('SELECT'),t('EMPTY_COMBO')].includes(value)) ? [value] : [])];
      setStates(prev => newData)
    }
  }


  useEffect(() => {
    tableAndColumnDropDownHandler({type: 'table'}, setTableOptions);
  }, [pdc]);

  useEffect(() => {
    dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "COLUMN_LOADING", data: {isLoading: false, isError: false}}));
    tableAndColumnDropDownHandler({type: 'table'}, setTableOptions, true);
    tableAndColumnDropDownHandler({type: 'column'}, setColumnOptions, true);
    return () => {
      setTable('');
      setColumn('');
    }
  }, [selectedNode?.key]);

  useEffect(() => {
    if(selectedNode?.key){
      setTable(selectedNode?.TABLE_NAME ? selectedNode?.TABLE_NAME : tableOptions?.[0] === t('SELECT') ? t('SELECT') : tableOptions?.[0] === t('EMPTY_COMBO') ? t('EMPTY_COMBO') : table);
    }
  }, [tableOptions, selectedNode?.key]);

  useEffect(() => {
    if(selectedNode?.key){
      setColumn(selectedNode?.COLUMN_NAME ? selectedNode?.COLUMN_NAME : columnOptions?.[0] === t('SELECT') ? t('SELECT') : columnOptions?.[0] === t('EMPTY_COMBO') ? t('EMPTY_COMBO') : column);
    }
  }, [columnOptions, selectedNode?.key]);

  useEffect(() => {
    tableAndColumnDropDownHandler({type: 'column'}, setColumnOptions);
  }, [table])

  return (
    <Stack spacing={"10px"} >
      <div className='flex'>
        <FormControl variant="outlined" className="width-100" size="small">
          <Autocomplete
            size="small"
            variant="outlined"
            className='width-100'
            options={tableOptions}
            value={table || ''}
            inputValue={table}
            onSelect={(event, newValue) => {
              handleChange('TABLE_NAME', event.target.value || '')
              setTable(event.target.value || '');
            }}
            onInputChange={(event, newInputValue) => {
              handleChange('TABLE_NAME', newInputValue)
              setTable(newInputValue)
            }}
            renderInput={(params) => <TextField 
              size="small" 
              variant="outlined" 
              {...params} 
              label={t("LBL_TABLE_NAME")}
              value={table || ''}
              onChange={(e) => {
                setTable(e.target.value);
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: tableLoading ? <CircularProgress size={"14px"} /> : params.InputProps.endAdornment
                
              }}
            />}
          />
        </FormControl>
      </div>
      <FormControl variant="outlined" className="width-100" size="small">
          <Autocomplete
            disabled={columnLoading || tableLoading}
            size="small"
            variant="outlined"
            className='width-100'
            options={columnOptions}
            value={column || ''}
            inputValue={column}
            onChange={(event, newValue) => {
              handleChange('COLUMN_NAME', newValue)
              setColumn(newValue);
            }}
            onInputChange={(event, newInputValue) => {
              handleChange('COLUMN_NAME', newInputValue)
              setColumn(newInputValue);
            }}
            renderInput={(params) => <TextField 
              size="small" 
              variant="outlined" 
              {...params} 
              label={t("LBL_COL_NM")}
              value={column || ''}
              onChange={(e) => {
                setColumn(e.target.value);
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: columnLoading ? <CircularProgress size={"14px"} /> : params.InputProps.endAdornment
                
              }}
            />}
          />
        </FormControl>
        <Snackbar
          open={showAlert.isOpen}
          autoHideDuration={3000}
          onClose={() => handleAlertClose()}>
          <Alert
            onClose={() => handleAlertClose()}
            severity={showAlert.type}
            variant="filled"
            sx={{ width: "100%" }}>
            {showAlert.mssg}
          </Alert>
        </Snackbar>
    </Stack>
  )
}
